<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <loading
    :active.sync="loading"
    :can-cancel="false"
    :is-full-page="true"
  ></loading>

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span><b-icon icon="people-fill" aria-hidden="true"></b-icon></span>
          <span>BANDA MULTIPLICADORA</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Crud_multiplicador</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Configuración de bandas multiplicadoras</p>
      </div>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col> </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button
                v-b-tooltip.hover
                title="Agregar nueva banda"
                variant="outline-primary"
                @click="abrirModal()"
                v-if="$localStorageService.can('Bloque_multipli_crear')"
                >Nueva banda
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!--   Tabla   -->

      <b-row>
        <b-col cols="12">
          <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos mt-4"
            fixed
          >
            <template v-slot:cell(fechaAlta)="row">
              {{ row.item.fechaAlta | formatoFechaCorta }}
            </template>
            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFechaCorta }}
            </template>
            <template v-slot:cell(registroActivo)="row">
              {{ row.item.registroActivo ? "Activo" : "Inactivo" }}
            </template>

            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                  title="Modificar banda"
                  size="sm"
                  variant="outline-warning"
                  @click="modificar(row.item)"
                  v-if="$localStorageService.can('Bloque_multipli_editar')"
                  ><em class="fa fa-pencil"></em
                ></b-button>
                <b-button
                  v-if="
                    !row.item.registroActivo &&
                    $localStorageService.can('Bloque_multipli_activar')
                  "
                  title="Activar banda"
                  variant="outline-success"
                  size="sm"
                  @click="activarDesactivarBloque(row.item)"
                  ><em class="fa fa-undo"></em
                ></b-button>
                <b-button
                  v-else-if="
                    $localStorageService.can('Bloque_multipli_activar')
                  "
                  title="Desactivar banda"
                  variant="outline-danger"
                  size="sm"
                  @click="activarDesactivarBloque(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="info" show
              >No hay datos</b-alert
            >
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-card>

    <!--  Modal  -->
    <b-modal
      v-model="modalAgregarBloque"
      :title="tituloModal"
      size="xl"
      scrollable
      no-close-on-backdrop
    >
      <b-card no-body>
        <b-tabs>
          <!-- Render Tabs, supply a unique `key` to each tab -->
          <b-tab title="Banda multiplicadora" active>
            <b-row class="mt-2">
              <b-col>
                <!--  {{especialidadArrayOrigen}}
                {{bloques.nombreEspecialidad}} -->
                <b-form-group align="left">
                  <label for="nombre">Especialidad </label>
                  <v-select
                    :options="especialidades"
                    :reduce="(esp) => esp.id"
                    label="especialidad"
                    v-model="banda.especialidad"
                    required
                    @input="validarEspecialidad()"
                  />
                  <b-form-invalid-feedback :state="banda.especialidad != null">
                    Se debe seleccionar la especialidad
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <div style="height: 150px"></div>
          </b-tab>
          <b-tab
            class="p-3"
            v-for="(i, index) in tabs"
            :key="'dyn-tab-' + i"
            :title="
              arrayTratamientos[index].nombreBanda != null
                ? (arrayTratamientos[index].emergencia ? '(Emergencia) ' : '') +
                  arrayTratamientos[index].nombreBanda
                : 'Banda ' + (index + 1)
            "
          >
            <div class="d-flex justify-content-between">
              <div>
                <b-form-checkbox
                  v-model="arrayTratamientos[index].emergencia"
                  @input="
                    asignarValoresEmergencia(arrayTratamientos[index], i, index)
                  "
                  switch
                >
                  ¿Es tratamiento de emergencia?
                </b-form-checkbox>
              </div>
              <div>
                <b-button
                  size="sm"
                  variant="info"
                  class="mr-3"
                  @click="limpiarTab(index)"
                >
                  Limpiar campos
                </b-button>
                <b-button
                  size="sm"
                  variant="secondary"
                  class="float-right"
                  @click="closeTab(i, index)"
                >
                  Eliminar banda
                </b-button>
              </div>
            </div>
            <b-form-group align="left">
              <label for="nombre">Tratamientos </label>
              <v-select
                v-if="arrayTratamientos[index].emergencia"
                :options="tratamientosEmergenciaEspecialidad"
                :reduce="(esp) => esp.idEspecialidad"
                label="nombreEspecialidad"
                v-model="arrayBandas[index].idTratamiento"
                @input="
                  asignarTratamiento(arrayBandas[index].idTratamiento, index)
                "
                required
              />
              <v-select
                v-else
                :options="tratamientosEspecialidad"
                :reduce="(esp) => esp.idEspecialidad"
                label="nombreEspecialidad"
                v-model="arrayBandas[index].idTratamiento"
                @input="
                  asignarTratamiento(arrayBandas[index].idTratamiento, index)
                "
                required
              />

              <!--
 -->
              <b-form-invalid-feedback
                :state="arrayBandas[index].idTratamiento"
              >
                Se debe seleccionar el tratamiento de la banda
              </b-form-invalid-feedback>
            </b-form-group>
            <div
            v-if="!arrayBandas[index].idTratamiento"
            style="margin-bottom: 20%;">

            </div>
            <b-table
            v-if="arrayBandas[index].idTratamiento"
              responsive
              striped
              hover
              :items="arrayBandas[index]"
              :fields="
                arrayTratamientos[index].emergencia
                  ? bandaZonasEmergencia
                  : bandaZonas
              "
              thead-tr-class="columnas"
              v-bind="arrayBandas[index]"
              style="margin-top: 2%"
            >
              <template #cell(idPrecio)="data">
                {{ data.value }}
              </template>
              <template #cell(nombreZona)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell()="{ item, field: { key } }">
                <span>
                  <b-form-input
                    v-if="
                      arrayTratamientos[index].emergencia &&
                      (key == 'tx_meta' || key == 'tx_min')
                    "
                    disabled
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="decimalesKeydown($event)"
                    @paste="onPaste"
                  ></b-form-input>

                 <!--  <b-form-input
                  v-if="
                    !arrayTratamientos[index].emergencia &&
                    (key == 'tx_meta' || key == 'tx_min')
                  "

                  v-model="item[key]"
                  :min="0"
                  step="1"
                  type="number"
                  @input="validarTxMeta(item)"
                  @keydown="negativoKeydown($event)"
                  @paste="onPaste"
                ></b-form-input> -->
                <b-form-input
                v-else-if="!arrayTratamientos[index].emergencia &&
                (key == 'tx_meta' || key == 'tx_min')"
                v-model="item[key]"
                :min="0"
                step="1"
                type="number"
                @keydown="decimalesKeydown($event)"
                @paste="onPaste"
                @input="validarRangoMetaBandas(item)"
              ></b-form-input> <!--  -->
                <b-form-input
                v-else
                v-model="item[key]"
                :min="0"
                step="1"
                type="number"
                @keydown="decimalesKeydown($event)"
                @paste="onPaste"
              ></b-form-input>
              <!--   <b-form-input
                v-if="
                  !arrayTratamientos[index].emergencia &&
                  (key == 'tx_min')
                "

                v-model="item[key]"
                :min="0"
                step="1"
                type="number"
                @input="validarTxMin(item)"
                @keydown="decimalesKeydown($event)"
                @paste="onPaste"
              ></b-form-input> -->
                 <!--  <b-form-input
                    v-if="!arrayTratamientos[index].emergencia &&
                    (key != 'tx_min' && key != 'tx_meta')"
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="decimalesKeydown($event)"
                    @paste="onPaste"
                  ></b-form-input> -->
                </span>
              </template>
            </b-table>
          </b-tab>

          <!-- New Tab Button (Using tabs-end slot) -->
          <template #tabs-end>
            <b-nav-item role="presentation" @click.prevent="newTab" href="#"
              >Agregar banda</b-nav-item
            >
          </template>

          <!-- Render this if no tabs -->
          <template #empty>
            <div class="text-center text-muted">
              There are no open tabs<br />
              Open a new tab using the <b>+</b> button above.
            </div>
          </template>
        </b-tabs>
      </b-card>

      <template v-slot:modal-footer>
        <b-button
          variant="outline-info"
          @click="guardarBloques()"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-secondary"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ConfiguracionComisionesEspecialista",
  components: { Header },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idTratamientoBanda: null,
    especialidadArrayOrigen: [],
    arrayZonaTodas: [
      {
        bonoIndividualOg: null,
        bonoTrimestral: null,
        comisionBaseEspecialistas: null,
        comisionBaseOG: null,
        comisionMasBonoEspecialistas: null,
        idZona: 10,
        precio: null,
        precioExtranjero: null,
        registroActivo: true,
        nombreZona: "TODAS",
      },
    ],
    arrayZonas: [], //ZONAS
    arrayBandas: [],
    aplicaTodasZonas: false,
    bandaZonas: [
      {
        key: "idPrecio",
        label: "Número de zona",
      },
      {
        key: "nombreZona",
        label: "Zona",
      },
      {
        key: "tx_meta",
        label: "Número de tx meta",
      },
      {
        key: "tx_min",
        label: "Número de tx mínimos",
      },
      {
        key: "pagoFijo",
        label: "Monto fijo de pago",
      },

    ],
    bandaZonasEmergencia: [
      {
        key: "idPrecio",
        label: "Número de zona",
      },
      {
        key: "nombreZona",
        label: "Zona",
      },
      {
        key: "tx_meta",
        label: "Número de tx meta",
      },
      {
        key: "tx_min",
        label: "Número de tx mínimos",
      },
      {
        key: "multiplicador",
        label: "Multiplicador",
      },
    ],
    fieldsZonas: [
      {
        key: "nombreZona",
        label: "Zona",
      },
      {
        key: "productividadMinima",
        label: "Productividad mínima",
      },
      {
        key: "productividadMeta",
        label: "Productividad meta para bono",
      },
      {
        key: "productividadObjetivo",
        label: "Productividad objetivo en clínica",
      },
      {
        key: "pagoGarantizado",
        label: "Pago garantizado",
      },
      {
        key: "bonoDesempeno",
        label: "Bono desempeño por tx",
      },
    ],
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null,
    },
    datosTabla: [],

    tituloModal: "",
    show: false,
    modalAgregarBloque: false,
    loader: false,
    fields: [
      { key: "idBanda", label: "ID", sortable: true },
      { key: "nombreEspecialidad", label: "Especialidad", sortable: true },
      { key: "fechaAlta", label: "Fecha alta", sortable: true },
      { key: "fechaModificacion", label: "Fecha modificación", sortable: true },
      { key: "usuarioAlta", label: "Usuario alta", sortable: true },
      {
        key: "usuarioModificacion",
        label: "Usuario modificación",
        sortable: true,
      },
      { key: "registroActivo", label: "Activar / Desactivar", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    colores: [],
    tiposSolicitud: [],
    loaderAcciones: false,
    datosGuardar: {
      idEstatusListaEspera: null,
      nombreEstatus: null,
      //proximaCita: true,
      slaMinimo: null,
      slaMaximo: null,
      idColor: 0,
      //registroActivo: true,
    },
    slaInicialValidacion: false,
    bloques: {
      idBloque: null,
      especialidad: null,
      duracionBloque: null,
      productividadMinima: null,
    },
    tabs: [],
    tabCounter: 0,
    especialidades: null,
    bandas: [{ idBanda: null, montoBanda: null }],
    blnHayMenosPrecio: false,
    faltanDatosDetalle: false,
    tratamientosEspecialidad: null,
    arrayTratamientos: [],
    banda: {
      idBanda: null,
      especialidad: null,
    },
    tratamientosEmergenciaEspecialidad: [],
    especialidadOriginal: null,
    existenRangosBandaEmpalmados: false,
    numeroTxFueraDeRango: [],
    banda1: [],
    banda2: [],
    hayTratamientosIguales: false,
    loading:false,

  }),
  validations: {
    datosGuardar: {
      nombreEstatus: { required },
      slaMinimo: { required },
      slaMaximo: { required },
      idColor: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarZonas();
    this.obtenerCatalogoBloques();
    this.obtenerCatalogoEspecialidades();
  },
  watch: {
    "arrayBandas.emergencia": function (val) {
      if (val) {
        this.arrayBandas.zonasBanda.forEach((banda) => {
          banda.tx_meta = 1;
          banda.tx_min = 1;
        });
      } else {
        this.arrayBandas.zonasBanda.forEach((banda) => {
          banda.tx_meta = 0;
          banda.tx_min = 0;
        });
      }
    },
  },
  methods: {
    validarRangoMetaBandas(item){
      let encontrado = null
      let banderaEncontro = false
      if (item.tx_min != 0 && item.tx_min != '' && item.tx_meta != 0 && item.tx_meta != '' ) {
        this.arrayBandas.forEach(element => {
        //  let encontrado = element.filter((banda) => (((item.tx_min >= banda.tx_min && item.min <= banda.tx_meta) || (item.tx_meta >= banda.tx_min && item.tx_meta <= banda.tx_meta)) && banda != item && item.tx_meta != 0 && item.tx_min != 0 && banda.tx_min != 0 && banda.tx_min != 0))

        //ultimo
        //        let encontrado = element.filter((banda) => (item.idPrecio == banda.idPrecio && (item.tx_min <= banda.tx_meta && item.tx_min >= banda.tx_min) || (item.tx_meta >= banda.tx_min && item.tx_meta <= banda.tx_meta)) && banda != item && ( item.tx_meta != 0 && item.tx_min != 0 && banda.tx_min != 0 && banda.tx_min != 0))
        encontrado = element.filter((banda) => (item.emergencia == false && banda.emergencia == false) && (item.idTratamiento == banda.idTratamiento) && (item.idPrecio == banda.idPrecio && banda != item) && ( item.tx_meta != 0 && item.tx_min != 0 && banda.tx_min != 0 && banda.tx_min != 0) && ((item.tx_min <= banda.tx_meta && item.tx_min >= banda.tx_min) || (item.tx_meta >= banda.tx_min && item.tx_meta <= banda.tx_meta)))
        if(encontrado.length > 0 ){
          banderaEncontro = true
          if(!this.numeroTxFueraDeRango.includes(item)){
            this.numeroTxFueraDeRango.push(item)
          }
        }
        });

      if (banderaEncontro == false) {
        let incluye = this.numeroTxFueraDeRango.filter(banda => banda == item)
        if (incluye.length > 0) {
          let index = this.numeroTxFueraDeRango.indexOf(incluye[0])
          this.numeroTxFueraDeRango.splice(index,1)
        }
      }

      this.banda1=this.arrayBandas[0];
      this.banda2=this.arrayBandas[1];
      }


    },
    validarTxMeta(event){
      if (event.tx_meta !== '' && event.tx_meta < event.tx_min) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "El número de tx meta no puede ser menor al número de tx mínimos",
        });
      }
    },
    validarTxMin(event){
      if (event.tx_min > event.tx_meta && event.tx_min != '') {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "El número de tx mínimos no puede ser mayor al número de tx mínimos",
        });
      }
    },
        validarEspecialidad() {
      let bandaConInfo = false;
      let numeroBanda = null;
      this.arrayBandas.forEach((element, index) => {
        let bandasConInfo = element.filter(
          (info) =>
            info.tx_meta != 0 ||
            info.tx_meta != '' ||
            info.tx_min != 0 ||
            info.tx_min != '' ||
            info.pagoFijo != 0 ||
            info.porcentaje != ''
        );

        if (
          bandasConInfo.length > 0
        ) {
          bandaConInfo = true;
          numeroBanda = index;
          return;
        }


      })

      if (bandaConInfo) {
          this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "La banda " +
            (numeroBanda + 1) +
            " contiene información, por favor elimine las bandas con información antes de cambiar la especialidad",
        });
        this.banda.especialidad = this.especialidadOriginal
        } else {
          this.especialidadOriginal =  this.banda.especialidad
          this.buscarTxEspecialidad(this.banda.especialidad);
          this.buscarTxEmergenciaEspecialidad(this.banda.especialidad);
        }
    },
    asignarValoresEmergencia(arrayTratamientos,i, index) {
      this.arrayBandas[index].idTratamiento = null;
      this.arrayTratamientos[index].nombreBanda = null;
      if (arrayTratamientos.emergencia) {
        this.limpiarTab(index);
        this.arrayTratamientos[index].emergencia = true;
        arrayTratamientos.idTratamiento = null;
        this.arrayBandas[index].forEach((banda) => {
          banda.tx_meta = 1;
          banda.tx_min = 1;
          banda.emergencia = true;
          banda.pagoFijo = 0;
          banda.multiplicador = 0;
          

        });
      } else {
        arrayTratamientos.idTratamiento = null;
        this.arrayBandas[index].forEach((banda) => {
          banda.tx_meta = 0;
          banda.tx_min = 0;
          banda.emergencia = false;
          banda.pagoFijo = 0;
        });
      }
    },
    buscarTxEmergenciaEspecialidad(idEspecialidad) {
      this.loader = true;
      this.$http
        .get(
          this.$api +
            "bandaMultiplicadora/obtenerTxEmergenciaEspecialidad?idEspecialidad=" +
            idEspecialidad
        )
        .then((respuesta) => {
          if (respuesta.data) {
            this.tratamientosEmergenciaEspecialidad = respuesta.data.data;

          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    asignarTratamiento(idTratamiento, index) {

      this.reiniciarDatos(index)

      let bandasRepetidas = []

      let bandaEsEmergencia = this.arrayBandas[index]

      this.arrayBandas.forEach((element,indexBanda) => {
        if(element.idTratamiento == idTratamiento && bandaEsEmergencia[0].emergencia == element[0].emergencia){
          bandasRepetidas.push(indexBanda)
        }
      });

      if (bandasRepetidas.length > 2 ) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "No se pueden agregar dos configuraciones de un mismo tratamiento",
        });
        this.tabs.splice(index, 1);
        this.arrayBandas.splice(index,1);
        this.arrayTratamientos.splice(index,1)
        return;
      }

      let bandasMismoTratamiento = []
      if (this.arrayTratamientos[index].emergencia == true) {
       // let bandasMismoTratamiento = this.arrayTratamientos.filter(banda => (banda.idTratamiento == idTratamiento) && (banda.emergencia == this.arrayTratamientos[index].emergencia) && (banda != this.arrayTratamientos[index]))
       this.arrayBandas.forEach((element,indexBanda) => {
        if(element.idTratamiento == idTratamiento && this.arrayTratamientos[index].emergencia == element[0].emergencia){
          bandasMismoTratamiento.push(indexBanda)
        }
      });
      if (bandasMismoTratamiento.length > 1) {
        this.hayTratamientosIguales = true;
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "No se pueden agregar dos mismos tratamientos de emergencia, por favor elimine uno",
        });
        this.tabs.splice(index, 1);
        this.arrayBandas.splice(index,1);
        this.arrayTratamientos.splice(index,1)
        return;
      }
    }

    const found = this.tratamientosEspecialidad.find(
        (element) => element.idEspecialidad == idTratamiento
      );
      this.arrayTratamientos[index].nombreBanda = found.nombreEspecialidad;
      this.arrayTratamientos[index].idTratamiento = idTratamiento
      this.arrayBandas[index].forEach((element) => {
        element.idTratamiento = idTratamiento;
      });
    },
    buscarTxEspecialidad(idEspecialidad) {
      this.loader = true;

      this.$http
        .get(
          this.$api +
            "bandaMultiplicadora/obtenerTxEspecialidad?idEspecialidad=" +
            idEspecialidad
        )
        .then((respuesta) => {
          if (respuesta.data) {
            this.tratamientosEspecialidad = respuesta.data.data;

          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onPaste() {
      event.preventDefault();
    },
    negativoKeydown(e) {
      if (["-", "e"].includes(e.key)) {
        e.preventDefault();
      }
    },
    decimalesKeydown(e) {
      if ([".","-", "e"].includes(e.key)) {
        e.preventDefault();
      }
    },

    agregarBanda() {
      this.bandas.push({
        idBanda: null,
        montoBanda: null,
      });
    },
    eliminarBanda(index) {
      this.bandas.splice(index, 1);
      this.arrayBandas.splice(index,1)
    },
    filterInput(e) {
      if (e.target != undefined) {
        e.target.value = e.target.value.replace(/[^0-9]+/g, "");
      }
    },

    filterKey(e) {
      const key = e.key;
      if (key === ".") return e.preventDefault();

      if (key === "e") return e.preventDefault();
    },
    llenarZonas() {
      this.$http
        .get(this.$api + "catalogos/listaPrecios")
        .then((response) => {
          if (response.status === 200) {
            // this.arrayZonas = response.data.data;

            this.arrayZonas = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.tx_meta = 0;
              o.tx_min = 0;
              o.multiplicador = 0;
              o.porcentaje = 0;
              return o;
            });

            this.arrayZonasBanda = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.tx_meta = 0;
              o.tx_min = 0;
              o.multiplicador = 0;
              o.porcentaje = 0;
              o.emergencia = false;
              o.idTratamiento = null;
              o.pagoFijo = 0;
              return o;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    limpiarTab(index) {

      this.arrayTratamientos[index].idTratamiento = null;
      this.arrayTratamientos[index].nombreBanda = null;
      this.arrayTratamientos[index].emergencia = false;

      this.arrayBandas[index].forEach((element) => {
        element.pagoFijo = 0;
        element.multiplicador = 0;
        element.porcentaje = 0;
        element.tx_min = 0;
        element.tx_meta = 0;
        element.idTratamiento = null;
      });
    },
    closeTab(x, index) {

      let obj = JSON.parse(JSON.stringify(this.arrayBandas));
      let campoLleno = false;
      this.numeroTxFueraDeRango.forEach((element,index) => {
        if (element.tx_meta == 0 && element.tx_min == 0) {
          this.numeroTxFueraDeRango.splice(index,1)
        }
      });
      if (this.numeroTxFueraDeRango.length == 0) {
        this.existenRangosBandaEmpalmados = false;
      }
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i] === x) {
          obj[index].forEach((banda) => {
            if (
              (banda.multiplicador != null && banda.multiplicador != 0) ||
              (banda.porcentaje != null && banda.porcentaje != 0) ||
              (banda.tx_meta != null && banda.tx_meta != 0) ||
              (banda.tx_min != null && banda.tx_min != 0)
            ) {
              campoLleno = true;
            }
          });

          if (campoLleno) {
            this.$swal.fire({
              icon: "warning",
              title: "Aviso",
              text: "La banda a eliminar no puede contener información, por favor vacíe los campos",
            });
          } else {
            this.tabs.splice(index, 1);
            this.arrayBandas.splice(index,1);
            this.arrayTratamientos.splice(index,1)

          }
        }
      }
    },
    newTab() {

      if(this.existenRangosBandaEmpalmados){
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Existen rangos de tx minimos y tx meta empalmados, por favor verifique la información antes de continuar",
        });
        return;
      }
      if (!this.banda.especialidad) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Debe seleccionar primero la especialidad antes de agregar bandas",
        });

        return;
      }
      this.tabs.push(this.tabCounter++);
      this.arrayBandas.push(JSON.parse(JSON.stringify(this.arrayZonasBanda)));
      this.arrayTratamientos.push({
        idTratamiento: null,
        nombreBanda: null,
        emergencia: false,
      });

    },

    slaKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    abrirModal() {
      this.existenRangosBandaEmpalmados = false;
      this.limpiarModal();
      this.tituloModal = "Nueva banda";
      this.llenarZonas();
      this.modalAgregarBloque = true;
    },
    obtenerCatalogoEspecialidades() {
      this.loader = true;
      this.$http
        .get(this.$api + "catalogos/obtenerEspecialidades")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data;
            /*  var arrayRespuesta = response.data.data.map((it) => {
                  return {
                    value: it.id,
                    text: it.especialidad,
                    color: it.color,
                    especialidadOrigen: it.especialidadOrigen,
                  };
                }); */

            this.especialidades = arrayRespuesta.filter(function (item) {
              return item.especialidadOrigen;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    obtenerCatalogoBloques() {
      this.loader = true;
      this.$http
        .get(this.$api + "bandaMultiplicadora/obtener")
        .then((respuesta) => {
          if (respuesta.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    guardarBloques() {
      this.loaderAcciones = true;
      this.loading = true;
      this.arrayBandas.forEach(item => {
        let bandasComunes = this.arrayBandas.filter( b => {
            let existe = false
            if (b[0].idTratamiento === item[0].idTratamiento) {

                existe = true;
              }
            return existe
          })
        this.existenRangosBandaEmpalmados = false;

        bandasComunes = JSON.parse(JSON.stringify(bandasComunes))
        if (bandasComunes.length > 1){
          for (let i = 0; i < bandasComunes.length; i++) {
            for (let j = 0; j < bandasComunes.length; j++) {
              for (let k = 0; k < bandasComunes.length; k++) {
                for (let l = 0; l < bandasComunes.length; l++) {

                  if (i!== k && (bandasComunes[i][j].tx_meta === bandasComunes[k][l].tx_meta && i!== k || bandasComunes[i][j].tx_min === bandasComunes[k][l].tx_min )){
                    this.existenRangosBandaEmpalmados = true;
                  }
                }
              }

            }
          }
         

        }

      })

   

      if(this.existenRangosBandaEmpalmados === true){
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Existen rangos de tx minimos y tx meta empalmados, por favor verifique la información antes de continuar",
        });
        this.loaderAcciones = false;
        this.loading = false;
        return;
      }

      if (this.banda.especialidad == null) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Por favor seleccione una especialidad antes de guardar",
        });
        this.loaderAcciones = false;
        this.loading = false;
        return;
      }


      var bandaVacia = false;
      let numeroBanda = null;
      let validarTxMeta= null;

      let bandas = [];
      this.arrayBandas.forEach((element, index) => {
        element.filter(
          (info) =>
            info.tx_meta == undefined ||
            info.tx_meta == null ||
            info.tx_min == undefined ||
            info.tx_min == null ||
            info.porcentaje == null ||
            info.porcentaje == undefined
        );

         validarTxMeta = element.filter((infoBanda) =>{
           if ( infoBanda.tx_meta !== '' && infoBanda.tx_min !== ''  && parseInt(infoBanda.tx_meta) < parseInt(infoBanda.tx_min)){
             return true;
           }else {
             return false;
           }
         }

        )
        if (
          element.idTratamiento == undefined ||
          element.idTratamiento == null
        ) {
          bandaVacia = true;
          numeroBanda = index;
          this.loaderAcciones = false;
          this.loading = false;
          return;
        }


        element.forEach((element) => {
          bandas.push(element);
        });
      });
      if(validarTxMeta != null && validarTxMeta.length > 0) {
          this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "El número de tx meta no puede ser menor al número de tx mínimo, por favor verificar la información",
        });
        this.loaderAcciones = false;
        this.loading = false;
        return;
        }

      if (bandaVacia) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text:
            "La banda " +
            (numeroBanda + 1) +
            " no tiene tratamiento, por favor agregue uno",
        });
        this.loaderAcciones = false;
        this.loading = false;
        return;
      }

      let parametros = {
        idBanda: this.banda.idBanda,
        idEspecialidad: this.banda.especialidad,
        bandas: bandas,
      };

      this.$http
        .post(this.$api + "bandaMultiplicadora/guardar", parametros)
        .then((respuesta) => {
          if (respuesta.data) {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: respuesta.data.data,
            });
          }
          this.cerrarModal();
          this.obtenerCatalogoBloques();
          this.bloques = {
            idBloque: null,
            especialidad: null,
            nombreEspecialidad: null,
            duracionBloque: null,
            productividadMinima: null,
          };
        }).finally(() => {
          this.loaderAcciones = false;
          this.loading = false;
        });
    },

     obtenerElementosRepetidos(array) {
  let elementosRepetidos = {};
  let resultados = [];

  for (let i = 0; i < array.length; i++) {
    let elemento = array[i].idTratamiento;

    if (elementosRepetidos[elemento] !== undefined) {
      if (elementosRepetidos[elemento] === false) {
        resultados.push(elemento);
        elementosRepetidos[elemento] = true;
      }
    } else {
      elementosRepetidos[elemento] = false;
    }
  }

  return resultados;
},

    modificar(item) {
      this.existenRangosBandaEmpalmados = false;
      this.banda.especialidad = item.idEspecialidad;
      this.banda.idBanda = item.idBanda;
      this.tabs = []
      this.arrayBandas = []
      this.arrayTratamientos = []

      this.buscarTxEspecialidad(item.idEspecialidad);
      this.buscarTxEmergenciaEspecialidad(item.idEspecialidad);

      this.$http
        .get(
          this.$api +
            "bandaMultiplicadora/obtenerDetalle?idBloque=" +
            item.idBanda
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            
            let bandas = JSON.parse(JSON.stringify(respuesta.data.data));
            let valoresUnicosIdGrupo = bandas.map(objeto => objeto.idGrupoBanda).filter((valor, indice, array) => array.indexOf(valor) === indice);

            valoresUnicosIdGrupo.forEach(idGrupo => {
              const result = bandas.filter(banda => banda.idGrupoBanda == idGrupo);

              let detalleTratamientos = {
                idTratamiento: result[0].idTratamiento,
                nombreBanda: this.nombreBanda(result[0].idTratamiento),
                emergencia: result[0].emergencia,
              };

              this.tabs.push(this.tabCounter++);
              this.arrayTratamientos.push(detalleTratamientos);
              result.idTratamiento = result[0].idTratamiento;
              this.arrayBandas.push(result);
            });

          }
        });

      this.bloques.idBloque = item.idBloque;
      this.tituloModal = "Modificar banda";
      this.modalAgregarBloque = true;
    },

    nombreBanda(idEspecialidad) {
      this.buscarTxEspecialidad();

      const found = this.tratamientosEspecialidad.find(
        (element) => element.idEspecialidad == idEspecialidad
      );
      return found.nombreEspecialidad;
    },
    activarDesactivarBloque(item) {
      const mensaje = item.registroActivo
        ? "¿Está seguro de desactivar la banda?"
        : "¿Está seguro de activar la banda?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .put(
              this.$api +
                "bandaMultiplicadora/activarDesactivarBanda?idBanda=" +
                item.idBanda
            )
            .then((respuesta) => {
              if (respuesta.data) {
                item.registroActivo = !item.registroActivo;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La banda se actualizó correctamente",
                });
              }
            });
        }
      });
    },

    cerrarModal() {
      this.modalAgregarBloque = false;
      this.limpiarModal();
    },

    limpiarModal() {
      this.banda = {
        especialidad: null,
        nombreEspecialidad: null,
      };

      this.tabs = [];
      this.arrayBandas = [];
      this.arrayTratamientos = [];
    },
    reiniciarDatos(index) {
      this.arrayBandas[index].forEach( i => {
        if (this.arrayTratamientos[index].emergencia){
          i.tx_meta = 1
          i.tx_min = 1
          i.multiplicador = 0
          i.precioFijo = null
        }else {
          i.tx_meta = 0
          i.tx_min = 0
          i.multiplicador = null
          i.precioFijo = 0
        }

      })
    }
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}


.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}
</style>
